import {
    ClockCircleFilled, CheckCircleFilled, ExclamationCircleFilled, CloseCircleFilled,
} from '@ant-design/icons';
import { t } from '@lingui/macro';
import React, { useEffect } from 'react';
import BukkuTooltip from '../../Tooltip';
import { Modal } from 'antd';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import MyInvoisActions from 'bukku/redux/MyInvois/actions';
import TransacionActions from 'bukku/redux/Transaction/actions';
import { usePrevious } from '../../../helpers/useReadStateSuccess';

const {
    refetchTransactionMyInvoisDocumentStatus,
    // resetMyInvoisDocument,
} = MyInvoisActions;

const {
    transactionReadAll,
    transactionRead,
} = TransacionActions;

const {
    readMyInvoisDocument,
    refetchMyInvoisDocumentStatus,
} = MyInvoisActions;

const selectorFn = state => ({
    myInvoisDocumentStatusRefetchState: state.MyInvois.myInvoisDocumentStatusRefetchState,
    lastReadDocumentStatus: state.MyInvois.lastReadDocumentStatus,
    lastReadAllRequest: state.Transaction.lastReadAllRequest,
});

export default function MyinvoisDocumentStatus({
    documentStatus,
    isConsolidated,
    // transactionId,
    // transactionType,
    canRefetchSubmitted,
    refetchSubmittedProps = {
        mode: 'list', // 'view' or 'list'
        transactionId: null,
        transactionType: null,
        myInvoisId: null,
    },
}) {
    let title, icon;
    const dispatch = useDispatch();
    const {
        myInvoisDocumentStatusRefetchState,
        lastReadAllRequest,
    } = useSelector(selectorFn, shallowEqual);

    const {
        transactionId,
        transactionType,
        myInvoisId,
    } = refetchSubmittedProps;

    const prevReadState = usePrevious(myInvoisDocumentStatusRefetchState);

    useEffect(() => {
        if (
            canRefetchSubmitted &&
            myInvoisDocumentStatusRefetchState === 'success' &&
            (prevReadState === 'request' || prevReadState === false)
        ) {
            switch (refetchSubmittedProps.mode) {
                case 'view': {
                    if (transactionId && transactionType)
                        dispatch(transactionRead(transactionType, transactionId));
                    else if (myInvoisId)
                        dispatch(readMyInvoisDocument(myInvoisId));

                    break;
                }
                case 'list': {
                    if (transactionType && transactionId)
                        dispatch(transactionReadAll(transactionType, lastReadAllRequest));

                    break;
                }
                default:
                    break;
            }
        }
    }, [
        myInvoisDocumentStatusRefetchState, lastReadAllRequest,
        documentStatus, canRefetchSubmitted, transactionId, transactionType,
        dispatch, prevReadState, refetchSubmittedProps.mode, myInvoisId,
    ]);

    switch (documentStatus) {
        case 'SUBMITTED':
            title = canRefetchSubmitted ? t`MyInvois Status: Processing (Click to Refresh)` : t`MyInvois Status: Processing`;
            icon = <ClockCircleFilled
                style={{
                    color: '#bfbfbf',
                    ...(canRefetchSubmitted ? { cursor: "pointer" } : {}),
                }}
                onClick={
                    e => {
                        if (canRefetchSubmitted) {
                            e.stopPropagation();
                            Modal.confirm({
                                title: t`Are you sure you want to fetch the latest MyInvois status?`,
                                content: t`This will update the MyInvois status of the transaction based on the latest information from LHDN.`,
                                onOk: () => {
                                    if (transactionId && transactionType) {
                                        dispatch(
                                            refetchTransactionMyInvoisDocumentStatus(
                                                transactionId, transactionType,
                                            ),
                                        );
                                    }
                                    else if (myInvoisId) {
                                        dispatch(refetchMyInvoisDocumentStatus(myInvoisId));
                                    }
                                    else {
                                        throw new Error('No transactionId or myInvoisId provided for refetching MyInvois status.');
                                    }
                                },
                            });
                        }
                    }
                }
            />; // gray-6
            break;
        case 'QUEUED':
            title = t`MyInvois Status: Queueing`;
            icon = <ClockCircleFilled
                style={{ color: '#8c8c8c'}} // gray-7
            />; // gray-6
            break;
        case 'VALID':
            title = t`MyInvois Status: Validated`;
            if (isConsolidated)
                icon = <CheckCircleFilled style={{ color: '#1677ff' }} />; // blue-6
            else
                icon = <CheckCircleFilled style={{ color: '#52c41a' }} />; // green-6

            break;
        case 'INVALID':
            title = t`MyInvois Status: Invalid`;
            icon = <ExclamationCircleFilled style={{ color: '#faad14' }} />; // gold-6
            break;
        case 'ERROR':
            title = t`MyInvois Status: Error`;
            icon = <ExclamationCircleFilled style={{ color: '#faad14' }} />; // gold-6
            break;
        case 'CANCELLED':
            title = t`MyInvois Status: Cancelled`;
            icon = <CloseCircleFilled style={{ color: '#f5222d' }} />; // red-6
            break;
        default:
            return null;
    }

    if (isConsolidated)
        title = `${title} ${t`(Conso)`}`;

    return <BukkuTooltip title={title}>{icon}</BukkuTooltip>;
}
